<template>
  <b-container>
    <b-modal
      id="deleteModal"
      ref="deleteModal"
      title="Delete Product"
      @hidden="handleHidden"
      @ok="handleOk"
    >
      <h3 font-size="12px">
        Please type
        <strong>DELETE</strong> to confirm your action
      </h3>
      <b-form-input id="name-input" v-model="value" name="delete" placeholder="DELETE"></b-form-input>

      <div slot="modal-footer" class="w-100">
        <b-button
          variant="danger"
          size="md"
          class="float-right"
          @click="handleSubmit()"
          :disabled="isValid()"
        >Delete</b-button>
        <b-button variant="primary" size="md" class="float-right mr-2" @click="closeModal()">Abort</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios';

export default {
  components: {},
  data() {
    return {
      checkDelete: 'DELETE',
      value: ''
    };
  },
  methods: {
    isValid() {
      if (this.value === 'DELETE') {
        return false;
      } else {
        return true;
      }
    },
    showModal() {
      this.$refs['deleteModal'].show();
    },
    closeModal() {
      this.$refs['deleteModal'].hide();
    },
    handleHidden() {
      this.$router.back();
    },
    handleSubmit() {
      let path = this.$route.path;
      path = path.replace('/delete', '');
      axios
        .delete(process.env.VUE_APP_BASE_URL + path)
        .then(response => {})
        .catch(e => {
          console.error(e);
        });

      this.$nextTick(() => {
        this.closeModal();
      });
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.showModal();
    });
  }
};
</script>

<style scoped>
input:valid {
  border-color: green;
}

input:invalid {
  border-color: red;
}
span.error {
  color: #9f3a38;
}
</style>